var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7903 12.3871L14.7071 12.2929C14.3466 11.9324 13.7794 11.9047 13.3871 12.2097L13.2929 12.2929L10.2929 15.2929L10.2515 15.3369L10.1963 15.4047L10.1247 15.5159L10.0712 15.6287L10.0358 15.734L10.0069 15.8819L10 16L10.0028 16.0752L10.0202 16.2007L10.0497 16.3121L10.0937 16.4232L10.146 16.5207L10.2197 16.6254L10.2929 16.7071L13.2929 19.7071C13.6834 20.0976 14.3166 20.0976 14.7071 19.7071C15.0676 19.3466 15.0953 18.7794 14.7903 18.3871L14.7071 18.2929L13.415 17H21C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15H13.415L14.7071 13.7071C15.0676 13.3466 15.0953 12.7794 14.7903 12.3871L14.7071 12.2929L14.7903 12.3871Z",
    fill: "#292F49"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back_btn.40e95984a53f2f84a31b25edb46d5fcb.svg";
export { ForwardRef as ReactComponent };